import { Checkbox, Form } from 'antd';
import classNames from 'classnames';

import { CheckboxNoEditIcon } from './CheckboxNoEditIcon';
import styles from './EditableCheckbox.module.scss';

interface Props {
  name?: string;
  label?: string;
  editing: boolean;
  checked?: boolean;
  disabled?: boolean;
  emptyNoSelected?: boolean;
  onChange?: (checked: boolean) => void;
}

export const EditableCheckbox = ({ name, label, editing, checked, disabled, emptyNoSelected, onChange }: Props) => {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className={classNames(styles.label, { [styles.disabled]: !editing || disabled })}>
      <div className={styles.controlContainer}>
        {editing ? (
          <Form.Item name={name} valuePropName="checked">
            <Checkbox checked={checked} onChange={(event) => onChange?.(event.target.checked)} />
          </Form.Item>
        ) : (
          <Form.Item>
            <CheckboxNoEditIcon isSelectedItem={checked} emptyNoSelected={emptyNoSelected} />
          </Form.Item>
        )}
      </div>
      {label}
    </label>
  );
};
